function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var GameTemplate = require('../../lib/templates/gametemplate');
var saito = require('../../lib/saito/saito');
var ChessGameRulesTemplate = require('./lib/chess-game-rules.template');
var ChessGameOptions = require('./lib/chess-game-options.template');
var ChessSingularGameOptions = require('./lib/chess-singular-game-options.template');
var chess = require('./lib/chess.js');
var chessboard = require('./lib/chessboard');
var htmlTemplate = require('./lib/game-html.template');

//const SaitoUser = require("../../lib/saito/ui/saito-user/saito-user");

var this_chess = null;
var Chessgame = /*#__PURE__*/function (_GameTemplate) {
  function Chessgame(app) {
    var _this;
    _classCallCheck(this, Chessgame);
    _this = _callSuper(this, Chessgame, [app]);
    _this.name = 'Chess';
    _this.slug = 'chess';
    _this.board = null;
    _this.engine = new chess.Chess();
    this_chess = _this;
    _this.icon = 'fa-sharp fa-solid fa-chess';
    _this.minPlayers = 2;
    _this.maxPlayers = 2;
    _this.title = 'Saito Chess';
    _this.styles.push('/chess/chessboard.css');
    _this.description = '"Minutes to learn, a lifetime to master" <br><br> Chess is the king of games and original application on the Saito Network. ';
    _this.categories = 'Games Boardgame Classic';
    _this.confirm_moves = 1;
    _this.can_play_async = 1;
    _this.insert_rankings = true;
    _this.clock.container = '#clock_';
    _this.roles = ['observer', 'white', 'black'];
    _this.app = app;
    return _this;
  }
  _inherits(Chessgame, _GameTemplate);
  return _createClass(Chessgame, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app) {
        var _this2 = this;
        var _this$game, _this$game2, i, newhtml, _i;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (this.browser_active) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!this.initialize_game_run) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              _context4.n = 3;
              return this.injectGameHTML(htmlTemplate());
            case 3:
              document.documentElement.setAttribute('data-theme', 'dark');

              //this.sizer.render();
              //this.sizer.attachEvents('#board');
              //this.app.browser.makeDraggable('#board');
              _context4.n = 4;
              return _superPropGet(Chessgame, "render", this, 3)([app]);
            case 4:
              //
              // ADD MENU
              //
              this.menu.addMenuOption('game-game', 'Game');
              if (this.game.player > 0) {
                if (!((_this$game = this.game) !== null && _this$game !== void 0 && _this$game.draw_offered)) {
                  this.menu.addSubMenuOption('game-game', {
                    text: 'Offer Draw',
                    id: 'game-draw',
                    "class": 'game-draw',
                    callback: function () {
                      var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, game_mod) {
                        var c, data;
                        return _regenerator().w(function (_context) {
                          while (1) switch (_context.n) {
                            case 0:
                              _context.n = 1;
                              return sconfirm('Offer to end the game in a draw?');
                            case 1:
                              c = _context.v;
                              if (!c) {
                                _context.n = 2;
                                break;
                              }
                              game_mod.game.draw_offered = -1; //Offer already sent
                              data = {
                                draw: 'offer'
                              };
                              game_mod.endTurn(data);
                              return _context.a(2);
                            case 2:
                              return _context.a(2);
                          }
                        }, _callee);
                      }));
                      function callback(_x2, _x3) {
                        return _callback.apply(this, arguments);
                      }
                      return callback;
                    }()
                  });
                }
                if (this.game.player == ((_this$game2 = this.game) === null || _this$game2 === void 0 ? void 0 : _this$game2.draw_offered)) {
                  this.menu.addSubMenuOption('game-game', {
                    text: 'Accept Draw',
                    id: 'game-draw',
                    "class": 'game-draw',
                    callback: function () {
                      var _callback2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, game_mod) {
                        var c, data;
                        return _regenerator().w(function (_context2) {
                          while (1) switch (_context2.n) {
                            case 0:
                              _context2.n = 1;
                              return sconfirm('Accept offer to end the game in a draw?');
                            case 1:
                              c = _context2.v;
                              if (!c) {
                                _context2.n = 2;
                                break;
                              }
                              game_mod.game.draw_offered = -1; //Offer already sent
                              data = {
                                draw: 'accept'
                              };
                              game_mod.endTurn(data);
                              return _context2.a(2);
                            case 2:
                              return _context2.a(2);
                          }
                        }, _callee2);
                      }));
                      function callback(_x4, _x5) {
                        return _callback2.apply(this, arguments);
                      }
                      return callback;
                    }()
                  });
                }
                this.menu.addSubMenuOption('game-game', {
                  text: 'Resign',
                  id: 'game-resign',
                  "class": 'game-resign',
                  callback: function () {
                    var _callback3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, game_mod) {
                      var c;
                      return _regenerator().w(function (_context3) {
                        while (1) switch (_context3.n) {
                          case 0:
                            _context3.n = 1;
                            return sconfirm('Do you really want to resign?');
                          case 1:
                            c = _context3.v;
                            if (!c) {
                              _context3.n = 2;
                              break;
                            }
                            game_mod.game.turn = ["resignation\t".concat(game_mod.game.player)];
                            game_mod.sendGameMoveTransaction('game', {});
                            //await game_mod.sendStopGameTransaction('resignation');
                            return _context3.a(2);
                          case 2:
                            return _context3.a(2);
                        }
                      }, _callee3);
                    }));
                    function callback(_x6, _x7) {
                      return _callback3.apply(this, arguments);
                    }
                    return callback;
                  }()
                });
              }
              this.menu.addSubMenuOption('game-game', {
                text: 'How to Play',
                id: 'game-rules',
                "class": 'game-rules',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.overlay.show(game_mod.returnGameRulesHTML());
                }
              });
              this.menu.addChatMenu();
              this.menu.render();
              this.log.render();
              this.playerbox.render();
              //Opt in to playerbox holding video call boxes
              this.playerbox.hostVideo();
              for (i = 1; i <= 2; i++) {
                this.playerbox.updateIcons("<div class=\"tool-item item-detail turn-shape ".concat(this.roles[i].toLowerCase(), "\"></div>"), i);
                newhtml = '';
                if (this.game.player == i) {
                  newhtml += "<div></div>";
                } else {
                  newhtml += "<div class=\"last_move\" id=\"last_".concat(i, "\"></div>");
                }
                if (this.useClock) {
                  newhtml += "<div class=\"player_clock\" id=\"clock_".concat(i, "\"></div>");
                }
                newhtml += "<div class=\"trophies\" id=\"trophies_".concat(i, "\"></div>");
                if (this.game.player == i) {
                  newhtml += "<div class=\"status\" id=\"status\"></div>";
                }
                this.playerbox.updateBody(newhtml, i);
              }
              if (this.game.player == 1) {
                $('.game-playerbox-manager').addClass('reverse');
              }
              if (this.useClock == 1) {
                this.clock.render();
                for (_i = 0; _i < this.game.clock.length; _i++) {
                  this.clock.displayTime(this.game.clock[_i].limit - this.game.clock[_i].spent, _i + 1);
                }
              }
              this.playerbox.setActive(this.game.target);
              window.onresize = function () {
                return _this2.board.resize();
              };
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "initializeGame",
    value: function () {
      var _initializeGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(game_id) {
        var _this$game3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              console.log('######################         #######################');
              console.log('##### INITIALIZE #####  CHESS  #######################');
              console.log('######################         #######################');

              //
              // There is no initializing in Chess -- finish initializing
              //
              if (this.game.initializing == 1) {
                this.engine.reset();
                this.game.queue.push('READY');
                //Check colors
                this.switchColors();
              }
              console.log((_this$game3 = this.game) === null || _this$game3 === void 0 ? void 0 : _this$game3.position);
              if (this.game.position != undefined) {
                this.engine.load(this.game.position);
              } else {
                this.game.position = this.engine.fen();
              }
              if (!this.game.state) {
                this.game.state = {
                  last: ''
                };
              }
              console.log(this.game.position, this.game.state);
              if (this.gameBrowserActive()) {
                _context5.n = 1;
                break;
              }
              console.log('nope out');
              return _context5.a(2);
            case 1:
              if (this.loadGamePreference('chess_expert_mode')) {
                this.confirm_moves = 0;
              }
              if (!this.board) {
                this.board = new chessboard('board', {
                  pieceTheme: '/chess/img/pieces/{piece}.png'
                });
              }
              if (this.game.over) {
                this.lockBoard(this.game.position);
              } else {
                this.setBoard(this.game.position);
              }

              //
              //game.target is initialized to 1, which is white (switched above if "player 1" wanted to be black)
              //
              console.log('Target/Player', this.game.target, this.game.player);
              if (this.game.target == this.game.player) {
                this.setPlayerActive();
              }
              this.updatePlayers();

              // If we have a fast-ish timed game turn off move confirmations initially
              if (this.useClock && parseInt(this.game.options.clock) < 15) {
                this.confirm_moves = 0;
              }
              this.game.draw_offered = this.game.draw_offered || 0;
            //this.attachGameEvents();
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function initializeGame(_x8) {
        return _initializeGame.apply(this, arguments);
      }
      return initializeGame;
    }() ////////////////
    // handleGame //
    ////////////////
  }, {
    key: "handleGameLoop",
    value: function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this$game4;
        var msg, mv, winnerColor, winner, cmd, loser, _winner, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              console.debug('QUEUE IN CHESS: ' + JSON.stringify(this.game.queue));
              msg = {};
              if (!(this.game.queue.length > 0)) {
                _context6.n = 3;
                break;
              }
              mv = this.game.queue.pop();
              if (!(mv == 'checkmate')) {
                _context6.n = 1;
                break;
              }
              winnerColor = this.engine.turn() === 'b' ? 'white' : 'black';
              winner = this.roles.indexOf(winnerColor);
              this.sendGameOverTransaction(this.game.players[winner - 1], 'checkmate');
              return _context6.a(2, 0);
            case 1:
              if (!mv.includes('resignation')) {
                _context6.n = 2;
                break;
              }
              cmd = mv.split('\t');
              loser = cmd.pop();
              _winner = 2 - loser;
              this.sendGameOverTransaction(this.game.players[_winner], 'resignation');
              return _context6.a(2, 0);
            case 2:
              msg.extra = JSON.parse(this.app.crypto.base64ToString(mv));
              _context6.n = 4;
              break;
            case 3:
              msg.extra = {};
              this.startClock();
              return _context6.a(2);
            case 4:
              if ((_this$game4 = this.game) !== null && _this$game4 !== void 0 && _this$game4.position) {
                console.log(this.game.position);
                this.engine.load(this.game.position);
                if (this.engine.in_check()) {
                  this.playerbox.setInactive();
                  this.playerbox.addClass('in_check', this.game.target);
                }
              }
              if (!(msg.extra == undefined)) {
                _context6.n = 5;
                break;
              }
              console.log('NO MESSAGE DEFINED!');
              return _context6.a(2);
            case 5:
              if (!(msg.extra.data == undefined)) {
                _context6.n = 6;
                break;
              }
              console.log('NO MESSAGE RECEIVED!');
              return _context6.a(2);
            case 6:
              //
              // the message we get from the other player
              // tells us the new board state, so we
              // update our own information and save the
              // game
              //
              data = JSON.parse(msg.extra.data);
              if (!data.draw) {
                _context6.n = 9;
                break;
              }
              if (!(data.draw === 'accept')) {
                _context6.n = 7;
                break;
              }
              console.log('Ending game');
              this.sendGameOverTransaction(this.game.players, 'draw');
              return _context6.a(2);
            case 7:
              //(data.draw == "offer")
              this.game.draw_offered = msg.extra.target; //I am receving offer
              if (this.game.player === msg.extra.target) {
                /*this.updateStatusMessage(
                	'Opponent offers a draw; ' + this.game.status
                );*/
              }
              this.initialize_game_run = 0;
              this.render(this.app);
              this.initialize_game_run = 1;
            case 8:
              return _context6.a(2);
            case 9:
              //if (this.game.draw_offered !== 0){
              //  this.game.draw_offered = 0; //No offer on table
              //this.attachGameEvents();
              //}

              this.game.last_position = this.game.position;
              this.game.position = data.position;
              this.updateLog(data.move);
              this.game.target = msg.extra.target;
              this.updateBoard(data.position);
              this.updatePlayers(msg.extra.target, data.move.substring(data.move.indexOf(':') + 2));

              //Check for draw according to game engine
              if (!(this.engine.in_draw() === true)) {
                _context6.n = 10;
                break;
              }
              this.sendGameOverTransaction(this.game.players, 'draw');
              return _context6.a(2, 0);
            case 10:
              if (this.engine.in_check()) {
                this.playerbox.setInactive();
                this.playerbox.addClass('in_check', this.game.target);
              } else {
                this.playerbox.setActive(this.game.target);
                $('.in_check').removeClass('in_check');
              }
              if (!(msg.extra.target == this.game.player)) {
                _context6.n = 11;
                break;
              }
              this.setPlayerActive();
              _context6.n = 13;
              break;
            case 11:
              if (!(this.engine.in_checkmate() === true)) {
                _context6.n = 12;
                break;
              }
              this.game.turn = ['checkmate'];
              this.sendGameMoveTransaction('game', {});

              //this.sendStopGameTransaction('checkmate');
              return _context6.a(2, 0);
            case 12:
              this.startClock();
            case 13:
              this.saveGame(this.game.id);
              return _context6.a(2, 0);
          }
        }, _callee6, this);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }()
  }, {
    key: "switchColors",
    value: function switchColors() {
      // observer skips
      if (this.game.player === 0 || !this.game.players.includes(this.publicKey)) {
        return 1;
      }

      //Game engine automatically randomizes player order, so we are good to go
      if (!this.game.options.player1 || this.game.options.player1 == 'random') {
        return 1;
      }

      // re-order the players so that originator can be the correct role
      if (this.game.options.player1 === 'white') {
        if (this.game.players[0] !== this.game.originator) {
          var p = this.game.players.shift();
          this.game.players.push(p);
        }
      } else {
        if (this.game.players[1] !== this.game.originator) {
          var _p = this.game.players.shift();
          this.game.players.push(_p);
        }
      }
      //Fix game.player so that it corresponds to the indices of game.players[]
      for (var i = 0; i < this.game.players.length; i++) {
        if (this.game.players[i] === this.publicKey) {
          this.game.player = i + 1;
        }
      }
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      this.lockBoard(this.game.position);
      if (this.game.over) {
        this.playerbox.setInactive();
        var cont = document.getElementById('commands-cont');
        if (cont) {
          cont.style.display = 'none';
        }
      }
    }
  }, {
    key: "endTurn",
    value: function endTurn(data) {
      var extra = {};
      extra.target = this.returnNextPlayer(this.game.player);
      extra.data = JSON.stringify(data);
      var data_to_send = this.app.crypto.stringToBase64(JSON.stringify(extra));
      this.game.turn = [data_to_send];
      this.moves = [];
      this.sendGameMoveTransaction('game', extra);
    }
  }, {
    key: "updatePlayers",
    value: function updatePlayers() {
      var _this3 = this;
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.game.target;
      var move = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.game.state.last;
      if (this.game.player == 0 || !this.gameBrowserActive()) {
        return;
      }
      for (var i = 1; i < 3; i++) {
        var captured = this.returnCapturedHTML(this.returnCaptured(this.engine.fen()), i);
        if (document.querySelector("#trophies_".concat(i))) {
          document.querySelector("#trophies_".concat(i)).innerHTML = captured;
        }
      }
      this.game.state.last = move;
      if (target == this.game.player) {
        if (document.querySelector('.last_move')) {
          document.querySelector('.last_move').innerHTML = this.game.state.last;
        }
      }
      if (document.querySelector('.last_move')) {
        document.querySelector('.last_move').onclick = function () {
          if (_this3.game.last_position) {
            _this3.setBoard(_this3.game.last_position);
            _this3.updateBoard(_this3.game.position);
          }
        };
      }
    }
  }, {
    key: "updateBoard",
    value: function updateBoard(position) {
      this.engine.load(position);
      if (this.gameBrowserActive()) {
        this.board.position(position, true);
      }
    }
  }, {
    key: "setBoard",
    value: function setBoard(position) {
      console.log('SETTING BOARD');
      this.engine.load(position);
      if (this.board != undefined) {
        if (this.board.destroy != undefined) {
          this.board.destroy();
        }
      }
      var cfg = {
        draggable: true,
        position: position,
        // pieceTheme: 'chess/pieces/{piece}.png',
        pieceTheme: '/chess/img/pieces/{piece}.png',
        onDragStart: this.onDragStart,
        onDrop: this.onDrop,
        onMouseoutSquare: this.onMouseoutSquare,
        onMouseoverSquare: this.onMouseoverSquare,
        onChange: this.onChange,
        moveSpeed: 400
      };
      if (this.gameBrowserActive()) {
        this.board = new chessboard('board', cfg);
        if (this.game.player == 2) {
          this.board.orientation('black');
        }
      }
    }
  }, {
    key: "lockBoard",
    value: function lockBoard(position) {
      console.log('LOCKING BOARD');
      if (this.board != undefined) {
        if (this.board.destroy != undefined) {
          this.board.destroy();
        }
      }
      var cfg = {
        pieceTheme: '/chess/img/pieces/{piece}.png',
        moveSpeed: 0,
        position: position
      };
      this.board = new chessboard('board', cfg);
      this.engine.load(position);
      if (this.game.player == 2) {
        this.board.orientation('black');
      }
    }

    //////////////////
    // Board Config //
    //////////////////
  }, {
    key: "onDragStart",
    value: function onDragStart(source, piece, position, orientation) {
      if (this_chess.game.target !== this_chess.game.player) {
        return false;
      }
      if (this_chess.engine.game_over() === true || this_chess.game.over || this_chess.engine.turn() === 'w' && piece.search(/^b/) !== -1 || this_chess.engine.turn() === 'b' && piece.search(/^w/) !== -1) {
        return false;
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(source, target, piece, newPos, oldPos, orientation, topromote) {
      this_chess.removeGreySquares();
      this_chess.game.move = this_chess.engine.fen().split(' ').slice(-1)[0] + ' ' + this_chess.colours(this_chess.engine.fen().split(' ')[1]) + ': ';
      this_chess.slot = target;

      //was a pawn moved to the last rank
      if (source.charAt(1) == 7 && target.charAt(1) == 8 && piece == 'wP' || source.charAt(1) == 2 && target.charAt(1) == 1 && piece == 'bP') {
        // check with user on desired piece to promote.
        this_chess.checkPromotion(source, target, piece.charAt(0));
      } else {
        // see if the move is legal
        var move = this_chess.engine.move({
          from: source,
          to: target,
          promotion: 'q' // NOTE: always promote to a queen for example simplicity
        });
        // illegal move
        if (move === null) return 'snapback';
        // legal move - make it

        this_chess.game.move += this_chess.pieces(move.piece) + ' ';
        this_chess.game.move += ' - ' + move.san;
        this_chess.confirmPlacement(function () {
          var data = {};
          data.position = this_chess.engine.fen();
          data.move = this_chess.game.move;
          this_chess.endTurn(data);
        });
      }
    }
  }, {
    key: "promoteAfterDrop",
    value: function promoteAfterDrop(source, target, piece) {
      var move = this_chess.engine.move({
        from: source,
        to: target,
        promotion: piece
      });

      // legal move - make it
      this_chess.game.move += "".concat(this_chess.pieces(move.piece), " - ").concat(move.san);
      var data = {};
      data.position = this.engine.fen();
      data.move = this.game.move;
      this.endTurn(data);
      this.updateLog('Pawn promoted to ' + this_chess.pieces(piece) + '.');
    }
  }, {
    key: "checkPromotion",
    value: function checkPromotion(source, target, color) {
      var _this4 = this;
      var html = ['q', 'r', 'b', 'n'].map(function (n) {
        return "<div class=\"action piece\" id=\"".concat(n, "\">").concat(_this4.piecehtml(n, color), "</div>");
      }).join('');
      html = "<div class=\"popup-confirm-menu promotion-choices\">\n              <div class=\"popup-prompt\">Promote to:</div>\n              ".concat(html, "\n              <div class=\"action\" id=\"cancel\"> \u2718 cancel</div>\n              </div>");
      var left = $("#board").offset().left;
      var top = $("#board").offset().top;
      if (this.slot) {
        left = $(".square-".concat(this.slot)).offset().left + $(".square-".concat(this.slot)).width();
        if (left + 100 > window.innerWidth) {
          left = $(".square-".concat(this.slot)).offset().left - 150;
        }
        top = $(".square-".concat(this.slot)).offset().top;
      }
      $('.popup-confirm-menu').remove();
      $('body').append(html);
      $('.popup-confirm-menu').css({
        position: 'absolute',
        top: top,
        left: left
      });
      if ($('.popup-confirm-menu').height() + top > window.innerHeight) {
        $('.popup-confirm-menu').css('top', window.innerHeight - $('.popup-confirm-menu').height());
      }
      $('.action').off();
      $('.action').on('click', function () {
        var confirmation = $(this).attr('id');
        $('.action').off();
        $('.popup-confirm-menu').remove();
        if (confirmation == 'cancel') {
          this_chess.setBoard(this_chess.game.position);
        } else {
          this_chess.promoteAfterDrop(source, target, confirmation);
        }
      });
    }
  }, {
    key: "onMouseoverSquare",
    value: function onMouseoverSquare(square, piece) {
      // get list of possible moves for this square
      var moves = this_chess.engine.moves({
        square: square,
        verbose: true
      });

      // exit if there are no moves available for this square
      if (moves.length === 0) {
        return;
      }

      // highlight the square they moused over
      this_chess.greySquare(square);

      // highlight the possible squares for this piece
      for (var i = 0; i < moves.length; i++) {
        this_chess.greySquare(moves[i].to);
      }
    }
  }, {
    key: "onMouseoutSquare",
    value: function onMouseoutSquare(square, piece) {
      this_chess.removeGreySquares();
    }
  }, {
    key: "removeGreySquares",
    value: function removeGreySquares() {
      var grey_squares = document.querySelectorAll('#board .square-55d63');
      Array.from(grey_squares).forEach(function (square) {
        return square.style.background = '';
      });
    }
  }, {
    key: "greySquare",
    value: function greySquare(square) {
      var squareEl = document.querySelector("#board .square-".concat(square));
      var background = '#c5e8a2';
      if (squareEl.classList.contains('black-3c85d') === true) {
        background = '#769656';
      }
      squareEl.style.background = background;
    }
  }, {
    key: "onChange",
    value: function onChange(oldPos, newPos) {
      if (this_chess.game.target !== this_chess.game.player) {
        //This gets called when I update my board for my opponents move
        //Don't want to accidentally trigger a Send Move
        return;
      }
    }
  }, {
    key: "confirmPlacement",
    value: function confirmPlacement(callback) {
      if (this.confirm_moves == 0) {
        callback();
        return;
      }
      var html = "\n          <div class=\"popup-confirm-menu\">\n            <div class=\"popup-prompt\">Are you sure?</div>\n            <div class=\"action\" id=\"confirm\"><div>\u2714</div><div>yes</div></div>\n            <div class=\"action\" id=\"cancel\"><div>\u2718</div><div>cancel</div></div>\n            <div class=\"confirm_check\"><input type=\"checkbox\" name=\"dontshowme\" value=\"true\"/> don't ask </div>\n          </div>";
      var left = $("#board").offset().left;
      var top = $("#board").offset().top;
      if (this.slot) {
        left = $(".square-".concat(this.slot)).offset().left + 1.5 * $(".square-".concat(this.slot)).width();
        if (left + 100 > window.innerWidth) {
          left = $(".square-".concat(this.slot)).offset().left - 150;
        }
        top = $(".square-".concat(this.slot)).offset().top;
      }
      $('.popup-confirm-menu').remove();
      $('body').append(html);
      $('.popup-confirm-menu').css({
        position: 'absolute',
        top: top,
        left: left
      });
      if ($('.popup-confirm-menu').height() + top > window.innerHeight) {
        $('.popup-confirm-menu').css('top', window.innerHeight - $('.popup-confirm-menu').height());
      }
      $('.action').off();
      $('.action').on('click', function () {
        var confirmation = $(this).attr('id');
        $('.action').off();
        $('.popup-confirm-menu').remove();
        if (confirmation == 'confirm') {
          callback();
        } else {
          this_chess.setBoard(this_chess.game.position);
        }
      });
      $('input:checkbox').change(function () {
        if ($(this).is(':checked')) {
          this_chess.confirm_moves = 0;
          this_chess.saveGamePreference('chess_expert_mode', 1);
        } else {
          this_chess.confirm_moves = 1;
        }
      });
    }
  }, {
    key: "colours",
    value: function colours(x) {
      switch (x) {
        case 'w':
          return 'white';
        case 'b':
          return 'black';
      }
      return;
    }
  }, {
    key: "pieces",
    value: function pieces(x) {
      switch (x) {
        case 'p':
          return 'Pawn';
        case 'r':
          return 'Rook';
        case 'n':
          return 'Knight';
        case 'b':
          return 'Bishop';
        case 'q':
          return 'Queen';
        case 'k':
          return 'King';
      }
      return;
    }
  }, {
    key: "returnCaptured",
    value: function returnCaptured(afen) {
      afen = afen.split(' ')[0];
      var WH = ['Q', 'R', 'R', 'B', 'B', 'N', 'N', 'P', 'P', 'P', 'P', 'P', 'P', 'P', 'P'];
      var BL = ['q', 'r', 'r', 'b', 'b', 'n', 'n', 'p', 'p', 'p', 'p', 'p', 'p', 'p', 'p'];
      for (var i = 0; i < afen.length; i++) {
        if (WH.indexOf(afen[i]) >= 0) {
          WH.splice(WH.indexOf(afen[i]), 1);
        }
        if (BL.indexOf(afen[i]) >= 0) {
          BL.splice(BL.indexOf(afen[i]), 1);
        }
      }
      return [WH, BL];
    }

    // player = number of opponent
  }, {
    key: "returnCapturedHTML",
    value: function returnCapturedHTML(acapt, player) {
      var captHTML = '';
      if (player == 2) {
        for (var i = 0; i < acapt[0].length; i++) {
          captHTML += this.piecehtml(acapt[0][i], 'w');
        }
      } else {
        for (var i = 0; i < acapt[1].length; i++) {
          captHTML += this.piecehtml(acapt[1][i], 'b');
        }
      }
      return captHTML;
    }
  }, {
    key: "piecehtml",
    value: function piecehtml(p, c) {
      return "<img class=\"captured\" alt=\"".concat(p, "\" src = \"/chess/img/pieces/").concat(c).concat(p.toUpperCase(), ".png\">");
    }
  }, {
    key: "returnGameRulesHTML",
    value: function returnGameRulesHTML() {
      return ChessGameRulesTemplate(this.app, this);
    }
  }, {
    key: "returnSingularGameOption",
    value: function returnSingularGameOption() {
      return ChessSingularGameOptions(this.app, this);
    }
  }, {
    key: "returnAdvancedOptions",
    value: function returnAdvancedOptions() {
      return ChessGameOptions(this.app, this);
    }
  }, {
    key: "returnShortGameOptionsArray",
    value: function returnShortGameOptionsArray(options) {
      var sgoa = _superPropGet(Chessgame, "returnShortGameOptionsArray", this, 3)([options]);
      var ngoa = {};
      for (var i in sgoa) {
        if (!(i == 'player1' && sgoa[i] == 'random')) {
          ngoa[i] = sgoa[i];
        }
      }
      return ngoa;
    }
  }]);
}(GameTemplate);
module.exports = Chessgame;